export const tag = {
	'field_tagCreateRequest.name': 'new tag name',
	'field_tagUpdateRequest.name': 'Tag name',
	'arithmetics-UNION': 'unite',
	'arithmetics-INTERSECTION': 'intersect',
	'arithmetics-DIFFERENCE': 'subtract',
}
export default tag;